// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".list-table[data-v-33b818f3] {\n  display: flex;\n  flex-direction: column;\n}\n.list-table .map[data-v-33b818f3] {\n  flex: 1;\n  height: 2.66667rem;\n}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
